import { REQUEST_STATUSES } from "@/constants";
import { getErrorResponse } from "@/utils/helper";

import { api } from "./instance";

export class HotspotService {
  static async getHotspots(propertyId, experienceId, elementId, query) {
    try {
      const resp = await api({
        method: "get",
        url: `/api/v2/hotspots/${propertyId}/${experienceId}/${elementId}`,
        params: query,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: { data: [], count: 0 },
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async getHotspot(propertyId, experienceId, elementId, hotspotId) {
    try {
      const resp = await api({
        method: "get",
        url: `/api/v2/hotspots/${propertyId}/${experienceId}/${elementId}/${hotspotId}`,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async addHotspot(propertyId, experienceId, elementId, data = {}) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/hotspots/${propertyId}/${experienceId}/${elementId}`,
        data,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async updateHotspot(propertyId, experienceId, elementId, hotspotId, data) {
    try {
      const resp = await api({
        method: "put",
        url: `/api/v2/hotspots/${propertyId}/${experienceId}/${elementId}/${hotspotId}`,
        data,
      });
      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async deleteHotspot(propertyId, experienceId, elementId, hotspotId) {
    try {
      const resp = await api({
        method: "delete",
        url: `/api/v2/hotspots/${propertyId}/${experienceId}/${elementId}/${hotspotId}`,
      });
      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }
}
